import React, { createContext, useCallback, useEffect, useState } from "react";

// Create a context with a default value
const LocationContext = createContext({
  location: null,
  setLocation: () => {},
});

const LocationProvider = ({ project, children }) => {
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [activeLocation, setActiveLocation] = useState(null);

  const updateActiveLocation = useCallback((location) => {
    setActiveLocation(null);
    setActiveLocation(location);
  });

  const fetchLocations = useCallback(async () => {
    let url = "/wp-json/greenpower/v1/locations";
    const response = await fetch(url);
    const data = await response.json();

    setLocations(data);

    if (project) {
      const matchedLocation = data.find(
        (location) => location.slug === project
      );

      if (matchedLocation) {
        setActiveLocation(matchedLocation);
      }
    }

    setLoading(false);
  });

  useEffect(() => {
    fetchLocations();
  }, []);

  const refreshLocations = async () => {
    setLoading(true);
    let url = "/wp-json/greenpower/v1/locations?refresh=true";
    const response = await fetch(url);
    const data = await response.json();
    setLocations(data);

    if (project) {
      const matchedLocation = data.find(
        (location) => location.slug === project
      );

      if (matchedLocation) {
        setActiveLocation(matchedLocation);
      }
    }

    setLoading(false);
  };

  return (
    <LocationContext.Provider
      value={{
        locations,
        setLocations,
        activeLocation,
        setActiveLocation,
        updateActiveLocation,
        loading,
        refreshLocations,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};

export { LocationContext, LocationProvider };
